import { UserMini } from "@infoland/iprova-api";
import { Hyperlink } from "@/types/todo/hyperlink";
import { Attachment } from "./attachment";

export interface Todo {
    /** Id of the todo */
    to_do_id: number;

    /** Name of the todo */
    title: string;

    /** State of the todo */
    state: to_do_state;

    /** Description of the todo */
    description: string;

    /** Note of the todo */
    note: string;

    /** Id of related task/case */
    case_id: number;

    /** Summary of related task/case */
    case_summary: string;

    /** Type of todo */
    type: to_do_type;

    /** Start Date Time of todo */
    start_date_time: Date;

    /** End Date Time of todo */
    end_date_time: Date;

    /** Deadline Date of todo */
    deadline_date: string;

    /** Resolved Actor Users of todo */
    resolved_actor_assignees: AssigneeMini[];

    /** Assigned By of todo */
    assigned_by: UserMini;

    /** Visibility of todo */
    visibility: visibility;

    /** Actors of todo */
    actors: TodoActor[];

    /** Title Translations of todo */
    title_translations: { key: string; value: string };

    /** Description Translations of todo */
    description_translations: { key: string; value: string };

    /** Hyperlinks of todo */
    hyperlinks: Hyperlink[];

    /** Attachments of todo */
    attachments: Attachment[];
}

export interface TodoActor {
    /** Id of the user */
    user_id: string;

    /** Id of the user group */
    user_group_id: string;

    /** Id of the team */
    team_id: string;

    /** Name of the actor */
    name: string;

    /** type of the actor */
    type: assignee_type;
}

export interface AssigneeMini {
    /** The id of the assignee*/
    assignee_id: string;
    /** Name of the assignee */
    name: string;
    /** Type of the assignee */
    type: assignee_type;
}

export enum to_do_type {
    fill_out_form = "fill_out_form",
    draw_casual_tree = "draw_casual_tree",
    other = "other"
}

export enum visibility {
    private = "private",
    public = "public"
}

export enum to_do_state {
    new = "new",
    active = "active",
    finished = "finished"
}
export enum assignee_type {
    user = "user",
    user_group = "user_group",
    team = "team"
}
